export const BREEDER_BREEDINGS_PATH = "/breeder/breedings";

export const breederBreedingPath = (breedingId: number) =>
  `${BREEDER_BREEDINGS_PATH}/${breedingId}`;

export const INSTALLER_BREEDINGS_PATH = "/installer/breedings";

export const installerBreedingPath = (breedingId: number) =>
  `${INSTALLER_BREEDINGS_PATH}/${breedingId}`;
